import React from 'react'
import Delegations from './DelegationListPage'

const delegationRoutes = [
  {
    breadcrumb: 'Delegations',
    path: '',
    element: <Delegations />,
    children: [],
  },
]

export default delegationRoutes
